// extracted by mini-css-extract-plugin
export default {"btn-full-width":"swal_alert_button_btn-full-width__Ji0-e","swal2-actions":"swal_alert_button_swal2-actions__PGtHa"};